<div class="modal-content">
    <div class="row">
        <div class="col-sm-12">
            <button class="close mr-4 mt-2" type="button" (click)="close()"><i class="fa fa-times"></i></button>
        </div>
    
        <ng-container *ngIf="confirmData && objectKeys(confirmData).length > 0">
            <div class="col-sm-12 px-5 mb-2 max-height">
                <div class="table-responsive">
                    <table class="table table-hover table-bordered">
                        <thead>
                            <tr>
                                <th class="bg-primary">Tipo</th>
                                <th class="bg-primary">Evento</th>
                                <th class="bg-primary">Alerta</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr [ngClass]="{'cursor-pointer': tablaRegCheq && tablaRegCheq.length > 0}" (click)="tablaRegCheq && tablaRegCheq.length > 0 ? (expandedRegCheq = !expandedRegCheq):null">
                                <td>1</td>
                                <td>Regcheq</td>
                                <td>
                                    <ng-container *ngTemplateOutlet="alertaTemplate; context: { $implicit: {campo: confirmData?.dataFraude?.alertaregcheq} }">
                                    </ng-container>
                                </td>
                            </tr>
                            <!--tablaRegCheq-->
                            <tr *ngIf="expandedRegCheq && tablaRegCheq && tablaRegCheq.length > 0">
                                <td colspan="3">
                                    <div class="expanded-panel">
                                        <div class="table-container">
                                            <table class="table border">
                                            <tr class="header-row">
                                                <th class="border-0">Rut</th>
                                                <th class="border-0">Ruc</th>
                                                <th class="border-0">Delito</th>
                                                <th class="border-0">Riesgo</th>
                                                <th class="border-0">Fecha Inicial</th>
                                                <th class="border-0">Fecha Último Mov</th>
                                            </tr>
                                            <tr class="table-row" *ngFor="let item of tablaRegCheq">
                                                <td class="cell"><span>{{item.rut ? (item.rut | rutFormat) : ''}}</span></td>
                                                <td class="cell"><span>{{item.ruc}}</span></td>
                                                <td class="cell"><span>{{item.delito}}</span></td>
                                                <td class="cell"><span>{{item.riesgo}}</span></td>
                                                <td class="cell"><span>{{item.fechaInicial}}</span></td>
                                                <td class="cell"><span>{{item.fechaUltimoMov}}</span></td>
                                            </tr>
                                            </table>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr [ngClass]="{'cursor-pointer': tablaListaNegra && tablaListaNegra.length > 0}" (click)="tablaListaNegra && tablaListaNegra.length > 0 ? (expandedListaNegra = !expandedListaNegra):null">
                                <td>1</td>
                                <td>Listas negras</td>
                                <td>
                                    <ng-container *ngTemplateOutlet="alertaTemplate; context: { $implicit: {campo: confirmData?.dataFraude?.alertalistanegra} }">
                                    </ng-container>
                                </td>
                            </tr>
                            <!--tablaListaNegra-->
                            <tr *ngIf="expandedListaNegra && tablaListaNegra && tablaListaNegra.length > 0">
                                <td colspan="3">
                                    <div class="expanded-panel">
                                        <div class="table-container">
                                            <table class="table border">
                                            <tr class="header-row">
                                                <th class="border-0">Rut</th>
                                                <th class="border-0">Nombre</th>
                                                <th class="border-0">Línea Negocios</th>
                                                <th class="border-0">Fecha Registro</th>
                                            </tr>
                                            <tr class="table-row" *ngFor="let item of tablaListaNegra">
                                                <td class="cell"><span>{{item.rut ? (item.rut | rutFormat) : ''}}</span></td>
                                                <td class="cell"><span>{{item.nombre}}</span></td>
                                                <td class="cell"><span>{{item.lineaNegocios}}</span></td>
                                                <td class="cell"><span>{{item.fechaRegistro ? (item.fechaRegistro | date: 'dd-MM-yyyy' : 'UTC') : ''}}</span></td>
                                            </tr>
                                            </table>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Antigüedad Salfa</td>
                                <td>
                                    <ng-container *ngTemplateOutlet="alertaTemplate; context: { $implicit: {campo: confirmData?.dataFraude?.alertaantiguesalfa} }">
                                    </ng-container>
                                </td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Cambio Socios</td>
                                <td>
                                    <ng-container *ngTemplateOutlet="alertaTemplate; context: { $implicit: {campo: confirmData?.dataFraude?.alertasocios} }">
                                    </ng-container>
                                </td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Timbraje documentos</td>
                                <td>
                                    <ng-container *ngTemplateOutlet="alertaTemplate; context: { $implicit: {campo: confirmData?.dataFraude?.alertadoc} }">
                                    </ng-container>
                                </td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Observaciones tributarias</td>
                                <td>
                                    <ng-container *ngTemplateOutlet="alertaTemplate; context: { $implicit: {campo: confirmData?.dataFraude?.alertaobsertribu} }">
                                    </ng-container>
                                </td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>Ventas y Compras</td>
                                <td>
                                    <ng-container *ngTemplateOutlet="alertaTemplate; context: { $implicit: {campo: confirmData?.dataFraude?.alertavyc} }">
                                    </ng-container>
                                </td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Bajo pago de IVA</td>
                                <td>
                                    <ng-container *ngTemplateOutlet="alertaTemplate; context: { $implicit: {campo: confirmData?.dataFraude?.alertabajoiva} }">
                                    </ng-container>
                                </td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Sin patrimonio</td>
                                <td>
                                    <ng-container *ngTemplateOutlet="alertaTemplate; context: { $implicit: {campo: confirmData?.dataFraude?.alertapatrimonio} }">
                                    </ng-container>
                                </td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Pocas facturas emitidas (entre 5-30 doc)</td>
                                <td>
                                    <ng-container *ngTemplateOutlet="alertaTemplate; context: { $implicit: {campo: confirmData?.dataFraude?.alertafactura} }">
                                    </ng-container>
                                </td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Pocas facturas recibidas (entre 5-30 doc)</td>
                                <td>
                                    <ng-container *ngTemplateOutlet="alertaTemplate; context: { $implicit: {campo: confirmData?.dataFraude?.alertafaccompra} }">
                                    </ng-container>
                                </td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Fechas de declaración (1 o 2 fechas rectifican año completo)</td>
                                <td>
                                    <ng-container *ngTemplateOutlet="alertaTemplate; context: { $implicit: {campo: confirmData?.dataFraude?.alertafechadec} }">
                                    </ng-container>
                                </td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Sin empleados</td>
                                <td>
                                    <ng-container *ngTemplateOutlet="alertaTemplate; context: { $implicit: {campo: confirmData?.dataFraude?.alertaempleados} }">
                                    </ng-container>
                                </td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>Consultas al Rut</td>
                                <td>
                                    <ng-container *ngTemplateOutlet="alertaTemplate; context: { $implicit: {campo: confirmData?.dataFraude?.alertaconsultalalrut} }">
                                    </ng-container>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </ng-container>

    </div>
</div>

<ng-template #alertaTemplate let-campo>
    <ng-container [ngSwitch]="campo?.campo">
        <ng-container *ngSwitchCase="0">
          <div class="circulo verde"></div>
        </ng-container>
        <ng-container *ngSwitchCase="1">
          <div class="circulo rojo"></div>
        </ng-container>
        <ng-container *ngSwitchDefault>
        </ng-container>
      </ng-container>
</ng-template>
